import { Module } from '@nestjs/common'
import {
	CustomerReservationController,
	CustomerReservationManagementController,
	ReservationController,
} from './controllers'
import { ReservationCronModule } from './cron'
import { GoogleReservationsModule } from './integrations'
import { ReservationManagementService, ReservationService, TimeslotService } from './services'
import { ReservationSharedModule } from './shared'

@Module({
	imports: [ReservationSharedModule, GoogleReservationsModule, ReservationCronModule],
	controllers: [ReservationController, CustomerReservationController, CustomerReservationManagementController],
	providers: [ReservationService, TimeslotService, ReservationManagementService],
})
export class ReservationModule {}
